'use client';

import { Upload } from 'lucide-react';

interface UploadIconProps {
  className?: string;
}

export function UploadIcon({ className = 'h-12 w-12' }: UploadIconProps) {
  return <Upload className={`text-muted-foreground ${className}`} />;
}
